const templateUrl = require('./views/skip-shipment-dialog.html');

const inject = ['shipmentOrchestrator', '$state', '$translate', 'dialogService', 'toastService'];

function SkipShipmentControllerFactory(shipmentOrchestrator, $state, $translate, dialogService, toastService) {
  class SkipShipmentController {
    skip() {
      return dialogService.open({
        templateUrl: templateUrl,
        confirmText: $translate.instant('MODAL_SKIP_SHIPMENT_SAVE'),
        onSuccess: () => shipmentOrchestrator.skipShipment(this.shipment.publicId)
          .then(() => toastService.translate.success('TOAST_SKIP_SHIPMENT_SUCCESS'))
          .then($state.reload)
          .catch(() => toastService.translate.danger('TOAST_SKIP_SHIPMENT_DANGER')),
        windowTopClass: 'og-skip-shipment-modal',
        ariaLabelledBy: 'og-skip-shipment-modal-title',
        ariaDescribedBy: 'og-skip-shipment-modal-description'
      }).result;
    }
  }

  return new SkipShipmentController();
}

SkipShipmentControllerFactory.$inject = inject;

const app = angular.module('msi.shipments.skipShipment.controller', []);

app.controller('SkipShipmentController', SkipShipmentControllerFactory);

module.exports = app.name;
